import { PasskeyManagement } from '@bz/account';

export const route = {
  info: {
    login: true,
  },
} satisfies RouteDefinition;

export default PasskeyManagement;
